export const PARAMS_KEY = 'params';
export const PATHNAME_KEY = 'pathname';
export const DEBTS_MODE_KEY = 'debts_mode';
